import React, { type ReactNode } from 'react';
import { Box } from '@atlaskit/primitives/compiled';
import { cssMap } from '@atlaskit/css';
import { Grid, GridColumn } from '@atlaskit/page';
import { token } from '@atlaskit/tokens';

export const TabContainer = ({ children }: { children: ReactNode }) => {
	return (
		<Box xcss={styles.tabContainer}>
			<Grid layout="fluid">
				<GridColumn>{children}</GridColumn>
			</Grid>
		</Box>
	);
};

const styles = cssMap({
	tabContainer: {
		flex: '1 1 auto',
		position: 'relative',
		paddingTop: token('space.0'),
		paddingRight: token('space.300'),
		paddingBottom: token('space.0'),
		paddingLeft: token('space.300'),
		height: '100%',
	},
});
